import { render, staticRenderFns } from "./MyBeansDetails.vue?vue&type=template&id=830c0f22&scoped=true"
import script from "./MyBeansDetails.vue?vue&type=script&lang=js"
export * from "./MyBeansDetails.vue?vue&type=script&lang=js"
import style0 from "./MyBeansDetails.vue?vue&type=style&index=0&id=830c0f22&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830c0f22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('830c0f22')) {
      api.createRecord('830c0f22', component.options)
    } else {
      api.reload('830c0f22', component.options)
    }
    module.hot.accept("./MyBeansDetails.vue?vue&type=template&id=830c0f22&scoped=true", function () {
      api.rerender('830c0f22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P1_Girls/MyBeans/MyBeansDetails.vue"
export default component.exports